export default function DateFilter({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  handleDateApply,
  handleClearDate,
}) {
  return (
    <div className="filter-section">
      <div className="filter-row">
        <label>From Date</label>

        <div className="date-wrapper">
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
          <i className="far fa-calendar-alt" />
        </div>

        <label>To Date</label>

        <div className="date-wrapper">
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          <i className="far fa-calendar-alt" />
        </div>

        <button className="btn-gold" onClick={handleDateApply}>
          Apply
        </button>

        <button className="btn-clear" onClick={handleClearDate}>
          Clear
        </button>
      </div>
    </div>
  );
}
